import { Typography } from '@mui/material';
import { useSlideContext } from '../../context';

import React from 'react';

export interface SlideTitleProps {
  readonly children: React.ReactNode;
  style?: React.CSSProperties;
}

export function SlideTitle({
  children,
  style,
}: SlideTitleProps): React.ReactElement {
  const { theme } = useSlideContext();

  return (
    <Typography
      sx={{
        color: theme.colors.primary,
        fontFamily: theme.fontFamily.headings,
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize.xl,
        ...style,
      }}
    >
      {children}
    </Typography>
  );
}
